import useResourceAllocationService from 'common/services/resource-allocation.service.versions';
import usePmSensorAuthId from 'components/hooks/PM/usePmSensorAuthId';
import { useContext, useEffect, useState } from 'react';
import { useDebounceCallback } from '@react-hook/debounce';

const useHeaderStats = ({ Context }) => {
  const {
    state: { period, filtersPayload, extraPayload, isInitialized }
  } = useContext(Context);
  const raService = useResourceAllocationService();
  const pmSensorAuthId = usePmSensorAuthId();
  const [stats, setStats] = useState({});

  const loadPeriodStats = useDebounceCallback(async () => {
    const statsRes = await raService.getSummary({
      sensor_authorization_id: pmSensorAuthId,
      before: period.before,
      after: period.after,
      filtersPayload,
      extraPayload
    });
    setStats(statsRes);
  }, 500);

  useEffect(() => {
    if (!isInitialized) return;
    loadPeriodStats();
  }, [isInitialized, period.before, period.after, filtersPayload]);

  return stats;
};

export default useHeaderStats;
